import { OrganizationUserAssociationType, UserType } from '@/gql/graphql';

export function getActiveUserOrganizationAssociation(
  user: UserType
): OrganizationUserAssociationType | null {
  return (
    user.organizationsAssociated?.find((assoc) => assoc?.removedAt == null) ||
    null
  );
}
